import React, { useState, useEffect } from 'react'
import translate from '../../reusable/translate'
import Tooltip from '../tooltip/Tooltip'

const TextArea = ({ commitment, language, target, title, maxLength, toolTip, validated, setValidated, handleChange, useTooltipLanguageOverride }) => {

    const  [charsLeft, setCharsLeft] = useState(maxLength)

    const setText = (value) => {
        handleChange(language, value)
    }

    useEffect(() => {
        setCharsLeft(maxLength - commitment[target].length)
    }, [target])

    const languageOverride = useTooltipLanguageOverride ? language : undefined;
    return(
        <div className={`margin-top-bot ${maxLength > 400 ? 'big-text-area' : ''}`}>
            <div className="flex-row space-between">
                <div className="flex-row">
                    <p className="p">{translate({ textKey: title, languageOverride: languageOverride })}</p>
                    <Tooltip textKey={toolTip} languageOverride={languageOverride} />
                </div>
                <p className="p">{charsLeft} {translate({ textKey: 'sit.commitment.operations.charsLeft', languageOverride: languageOverride })}</p>
            </div>
            <textarea
                className={`text-area ${validated ? '' : 'validated-text-area'}`}
                name={title}
                value={commitment[target]}
                rows="10"
                maxLength={maxLength}
                onChange={(e) => {
                    setText(e.target.value)
                    setValidated()
                    setCharsLeft(maxLength - e.target.value.length)
                }
                }/>
        </div>
    )
}

export default TextArea


// WEBPACK FOOTER //
// ./src/components/materialCommitment/commitment/TextArea.jsx